export default "__VITE_ASSET__d6edd05b__"